import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const DashboardLayoutIcon = forwardRef(({ title = 'Dashboard Layout Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 16 16" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M7.46 4A3.46 3.46 0 1 1 .54 4a3.46 3.46 0 0 1 6.92 0M15 6.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5m-3 2.04a3.46 3.46 0 1 0 0 6.92 3.46 3.46 0 0 0 0-6.92M7 14.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5" })));
});
//# sourceMappingURL=dashboard_layout_icon.js.map